import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { canActivateAdmin } from './auth/guards/admin-guard';
import { canActivateProcessManager } from './auth/guards/process-manager-guard';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SeasonCreateComponent } from './season/components/season-create-edit/season-create/season-create.component';
import { SeasonEditComponent } from './season/components/season-create-edit/season-edit/season-edit.component';
import { SeasonSuccessComponent } from './season/components/season-create-edit/season-success/season-success.component';
import { PayoutSuccessComponent } from './season/components/season-details/payout-success/payout-success.component';
import { SeasonDetailsComponent } from './season/components/season-details/season-details.component';
import { SeasonsOverviewComponent } from './season/components/season-list/seasons-overview/seasons-overview.component';
import { seasonStatusGuard } from './season/guards/season-status.guard';
import { UserManagementWrapperComponent } from './user-management/user-management.component';
import { WorkersCouncilGroupListComponent } from './workers-council-group/components/workers-council-group-list/workers-council-group-list.component';

export const APP_ROUTES: Routes = [
    {
        path: '',
        component: DashboardComponent,
        canActivate: [MsalGuard, canActivateProcessManager],
        pathMatch: 'full'
    },
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.routes').then(r => r.AUTH_ROUTES)
    },
    {
        path: 'seasons',
        component: SeasonsOverviewComponent,
        canActivate: [MsalGuard, canActivateProcessManager]
    },
    {
        path: 'season/success',
        component: SeasonSuccessComponent,
        canActivate: [MsalGuard, canActivateAdmin]
    },
    {
        path: 'season/create',
        component: SeasonCreateComponent,
        canActivate: [MsalGuard, canActivateAdmin]
    },
    {
        path: 'season/:seasonId',
        component: SeasonEditComponent,
        canActivate: [MsalGuard, canActivateAdmin, seasonStatusGuard]
    },
    {
        path: 'user-management',
        component: UserManagementWrapperComponent,
        canActivate: [MsalGuard, canActivateAdmin]
    },
    {
        path: 'translations',
        loadChildren: () => import('./translations/translations.routes').then(r => r.TRANSLATIONS_ROUTES),
        canActivate: [MsalGuard, canActivateAdmin]
    },
    {
        path: 'workers-council-groups',
        component: WorkersCouncilGroupListComponent,
        canActivate: [MsalGuard, canActivateAdmin]
    },
    {
        path: 'season-details/:seasonId',
        component: SeasonDetailsComponent,
        canActivate: [MsalGuard, canActivateProcessManager]
    },
    {
        path: 'payout-success',
        component: PayoutSuccessComponent,
        canActivate: [MsalGuard, canActivateProcessManager]
    },
    {
        path: '**',
        redirectTo: ''
    }
];
